// extracted by mini-css-extract-plugin
export default {"barContainer":"DetailsFullScreenIcon_barContainer__xJXhQ"};